import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../utils/api';

export const fetchProducts = createAsyncThunk('entities/fetchProducts', async () => {
  const res = await api.get('/products');
  return res.data;
});

export const fetchPriorities = createAsyncThunk('entities/fetchPriorities', async () => {
  const res = await api.get('/priorities');
  return res.data;
});

export const fetchCategories = createAsyncThunk('entities/fetchCategories', async () => {
  const res = await api.get('/categories');
  return res.data;
});

export const fetchIssueTypes = createAsyncThunk('entities/fetchIssueTypes', async () => {
  const res = await api.get('/issue-types');
  return res.data;
});

export const fetchUsers = createAsyncThunk('entities/fetchUsers', async () => {
  const res = await api.get('/users');
  return res.data;
});

const slice = createSlice({
  name: 'entities',
  initialState: {
    products: [],
    priorities: [],
    categories: [],
    issueTypes: [],
    users: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.fulfilled, (state, action) => { state.products = action.payload; })
      .addCase(fetchPriorities.fulfilled, (state, action) => { state.priorities = action.payload; })
      .addCase(fetchCategories.fulfilled, (state, action) => { state.categories = action.payload; })
      .addCase(fetchIssueTypes.fulfilled, (state, action) => { state.issueTypes = action.payload; })
      .addCase(fetchUsers.fulfilled, (state, action) => { state.users = action.payload; });
  },
});

export default slice.reducer;
